import { Link } from "@tanstack/react-router";
import {
  AlertTriangle,
  ArrowLeftRight,
  BadgePercent,
  Calculator,
  Calendar,
  Clock,
  CreditCard,
  FileSignature,
  FileText,
  Gauge,
  GitFork,
  Handshake,
  Landmark,
  Link2,
  ListChecks,
  MessageCircle,
  Percent,
  PiggyBank,
  Receipt,
  Search,
  ShieldAlert,
  ShieldCheck,
  Table,
  Tag,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import type { Tool } from "@/lib/tools";
import { categories } from "@/lib/tools";

// Mapa explícito: permite tree-shaking real (vs `import * as Icons` que puxa
// a lib inteira ~700KB pro bundle).
const ICONS: Record<string, LucideIcon> = {
  AlertTriangle,
  ArrowLeftRight,
  BadgePercent,
  Calculator,
  Calendar,
  Clock,
  CreditCard,
  FileSignature,
  FileText,
  Gauge,
  GitFork,
  Handshake,
  Landmark,
  Link2,
  ListChecks,
  MessageCircle,
  Percent,
  PiggyBank,
  Receipt,
  Search,
  ShieldAlert,
  ShieldCheck,
  Table,
  Tag,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  Wrench,
};

export function ToolCard({ tool }: { tool: Tool }) {
  const Icon = ICONS[tool.icon] ?? Wrench;
  const cat = categories.find((c) => c.id === tool.category);

  const content = (
    <div className="group relative h-full rounded-2xl border border-border bg-gradient-card p-6 shadow-soft transition-all md:hover:shadow-elevated md:hover:-translate-y-1">
      <div className="flex items-start justify-between mb-4">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors md:group-hover:bg-primary md:group-hover:text-primary-foreground">
          <Icon className="h-5 w-5" />
        </div>
        {!tool.available && (
          <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground bg-muted px-2 py-1 rounded-full">
            em breve
          </span>
        )}
      </div>
      <h3 className="font-display font-semibold text-base leading-snug mb-1.5">{tool.title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed">{tool.short}</p>
      {cat && (
        <div
          className={`mt-4 inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-full ${cat.color}`}
        >
          {cat.label}
        </div>
      )}
    </div>
  );

  if (!tool.available) return <div className="opacity-70 cursor-not-allowed">{content}</div>;
  return (
    <Link to="/ferramentas/$slug" params={{ slug: tool.slug }}>
      {content}
    </Link>
  );
}
